import React from 'react'
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { IconButton } from "@material-ui/core";
import { Marker } from '@urbica/react-map-gl';


import config from '../config.json';
import StyleSheet from '../commonComponents/StyleSheet';

interface Props {
  latitude: number;
  longitude: number;
}

const LocationMarker: React.FunctionComponent<Props> = ({
  latitude,
  longitude,
}) => {
  if (latitude !== 0 && longitude !== 0) {
    return (
      <Marker longitude={longitude} latitude={latitude}>
        <IconButton disabled>
          <LocationOnIcon style={styles.locationIcon} />
        </IconButton>
      </Marker>
    );
  } else {
    return null;
  }
};

const styles = StyleSheet.create({
  locationIcon: {
    color: config.marker.color,
    width: config.marker.width,
    height: config.marker.height,
  },
});

export default LocationMarker;
